import { useAuth } from "../../../authentication/authHelpers";
import { postAnnouncement, editAnnouncement } from "../utils/methods";
import { useSelector } from "react-redux";
import { notificationNoPostToDepartment } from "../../../utils/sendNotification";
import { Select, Input, Modal, DatePicker, Form, message } from "antd";
import { ModalXIcon } from "../../../assets/icons";
import dayjsTZ from "../../../utils/dayjs";
import { RichTextEditor } from "../../commonComponents";
import "./NewAnnouncement.scss";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { useEffect } from "react";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";

const NewAnnouncement = ({ data, open, gridApi, setOpen, retrievedData }) => {
  const auth = useAuth();
  const { Option } = Select;
  const [form] = Form.useForm();

  const { departments } = useSelector((state) => state.departments);
  const { users, isDarkMode } = useSelector((state) => state.usersList);
  const { activeEmployees } = useSelector((state) => state.employeesList);

  //region SUBMIT
  const onSubmit = () => {
    form
      .validateFields()
      .then(async (res) => {
        const createdBy = !!auth?.user
          ? auth.user.given_name + " " + auth.user.family_name
          : undefined;
        const {
          endAnnouncementDate,
          announcementTeam = [],
          announcementTarget = [],
          announcementTitle,
          announcementBody,
        } = res;
        const newAnnouncement = {
          ...res,
          createdBy,
          userResponses: {},
          announcementId: data?.announcementId || "",
          announcementTarget: { departments: announcementTarget },
          announcementTeam: { teams: announcementTeam },
          endAnnouncementDate: endAnnouncementDate?.valueOf(),
        };
        if (!data) {
          await postAnnouncement(newAnnouncement)
            .then((r) => {
              gridApi.applyTransaction({ add: [r], addIndex: 0 });
              message.success("Announcement created successfully");
              const announcementTeamTarget = (activeEmployees || []).filter(
                (a) => announcementTeam.includes(a.employeeTeam)
              );
              const usersToPost = (users?.allUsers?.Items || []).filter(
                (e) =>
                  announcementTarget.includes(e.department) &&
                  announcementTeamTarget.some((a) => a.userSub === e.userSub)
              );
              notificationNoPostToDepartment(
                {
                  notificationTitle: announcementTitle,
                  content: "Ju keni nje lajmerim te ri",
                },
                usersToPost
              );
              // sendNotification({
              // 	headings: { en: announcementTitle },
              // 	contents: { en: "Ju keni nje lajmerim te ri" },
              // 	url: announcementUrl || "https://portal.flex.al/kryefaqja",
              // 	// included_segments: ["s"]
              // 	// data: {
              // 	//   ids: [
              // 	//     { user: auth.userAccess[0].email, read: false, removed: false },
              // 	//   ],
              // 	// },
              // });
              setOpen(false);
            })
            .catch((e) => {
              console.log(e);
              message.error("Nuk u krijua lajmerimi. Provoni perseri.");
            });
        } else {
          if (!data.announcementId) {
            message.error("ID e lajmerimit mungon.");
            return;
          }
          await editAnnouncement(data.announcementId, {
            announcementTitle,
            announcementBody,
          }).then(() => {
            retrievedData();
            message.success("Announcement edited successfully!");
            setOpen(false);
          });
        }
      })
      .catch((err) => console.log("Error validating form: ", err));
  };

  const onCleanUp = () => {
    setOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    if (!data) return;

    const { createdAt, endAnnouncementDate, ...rest } = data;
    for (const [key, value] of Object.entries(rest)) {
      if (key === "announcementTarget") {
        form.setFieldValue(key, value.departments);
      } else if (key === "announcementTeam") {
        form.setFieldValue(key, value.teams);
      } else {
        form.setFieldValue(key, value);
      }
    }
  }, []);

  //region RETURN
  return (
    <Modal
      centered
      open={open}
      width={1200}
      onCancel={onCleanUp}
      destroyOnHidden={true}
      wrapClassName="new-announcemenet-modal"
      title={data ? "Ndrysho Lajmërimin" : "Krijo Lajmërimin"}
      closeIcon={<ModalXIcon />}
      className={isDarkMode ? "dark darkHeader" : " lightHeader"}
      footer={[
        <MondayButton onClick={onCleanUp} className="mondayButtonRed">
          Anullo
        </MondayButton>,
        <MondayButton
          onClick={onSubmit}
          className="mondayButtonGreen"
          Icon={data ? <CheckOutlined /> : <PlusOutlined />}
        >
          {data ? "Ndrysho Lajmërimin" : "Aktivizo Lajmërimin"}
        </MondayButton>,
      ]}
    >
      <Form form={form}>
        <div className="new-announcemenet-content">
          <div className="formItem">
            <h3>Titulli</h3>
            <Form.Item
              name="announcementTitle"
              rules={[
                {
                  required: true,
                  message: "Kjo fushë është e detyrueshme.",
                },
              ]}
            >
              <Input
                // defaultValue={data?.announcementTitle}
                placeholder="Shkruaj titullin"
              />
            </Form.Item>
          </div>
          <div className="formItem">
            <h3>Përmbajtja</h3>
            <Form.Item
              name="announcementBody"
              rules={[
                {
                  required: true,
                  message: "Kjo fushë është e detyrueshme.",
                },
              ]}
            >
              <RichTextEditor
                // defaultValue={data?.announcementBody}
                className={"modal-quill-edit"}
              />
            </Form.Item>
          </div>
          <div className="newAnnouncementDropdowns">
            <div className="formItem">
              <h3>Kategoria</h3>
              <Form.Item
                name="announcementCategory"
                rules={[
                  {
                    required: true,
                    message: "Kjo fushë është e detyrueshme.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  // defaultValue={data?.announcementCategory}
                  disabled={!!data}
                  placeholder="Zgjidh kategorine"
                  classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
                >
                  <Option value="importantAnnouncement">Lajmërim</Option>
                  <Option value="needAction">
                    Lajmërim që ka nevojë për përgjigje
                  </Option>
                  <Option value="otherWish">Urim</Option>
                </Select>
              </Form.Item>
            </div>
            <div className="formItem">
              <h3>Url</h3>
              <Form.Item
                name="announcementUrl"
                rules={[
                  {
                    required: true,
                    message: "Kjo fushë është e detyrueshme.",
                  },
                ]}
              >
                <Input
                  style={{ width: "100%" }}
                  placeholder="vendos linkun e lajmërimit"
                  disabled={!!data}
                  // defaultValue={data?.announcementUrl}
                />
              </Form.Item>
            </div>
            <div className="formItem">
              <h3>Departamenti</h3>
              <Form.Item
                name="announcementTarget"
                rules={[
                  {
                    required: true,
                    message: "Kjo fushë është e detyrueshme.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  mode="multiple"
                  classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
                  disabled={!!data}
                  // defaultValue={data?.announcementTarget?.departments || []}
                  placeholder="Zgjidh Departamentet"
                >
                  {departments?.map((item) => {
                    return (
                      <Option
                        key={item.departmentId}
                        value={item.departmentName}
                      >
                        {item.departmentName}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </div>
            <div className="formItem">
              <h3>Kompania</h3>
              <Form.Item
                name="announcementTeam"
                rules={[
                  {
                    required: true,
                    message: "Kjo fushë është e detyrueshme.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
                  mode="multiple"
                  disabled={!!data}
                  // defaultValue={data?.announcementTeam?.teams || []}
                  placeholder="Zgjidh kompanite"
                >
                  <Option value="Flex Tirana">Flex Tirana</Option>
                  <Option value="Flex Prishtina">Flex Prishtina</Option>
                </Select>
              </Form.Item>
            </div>
            <div className="formItem">
              <h3>Data përfundimtare</h3>
              <Form.Item
                name="endAnnouncementDate"
                rules={[
                  {
                    required: true,
                    message: "Kjo fushë është e detyrueshme.",
                  },
                ]}
              >
                <DatePicker
                  classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
                  format={"DD/MM/YYYY"}
                  disabledDate={(e) => {
                    let disabled = false;
                    if (e?.valueOf() < dayjsTZ().startOf("day").valueOf())
                      disabled = true;
                    return disabled;
                  }}
                  style={{ width: "100%" }}
                  defaultValue={
                    !!data?.endAnnouncementDate
                      ? dayjsTZ(data?.endAnnouncementDate)
                      : null
                  }
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default NewAnnouncement;
